import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanLongStayParams } from "./long-stay-params";
import { QuestionPlanShortStayParams } from "./short-stay-params";

import type { PlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	stayLength: PlanCategoriesAndManagerStore["stayLength"];
};

export const QuestionPlanStayLength = ({ stayLength }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="滞在期間・連泊設定" categoryStore={stayLength}>
			<QuestionPlanLongStayParams />
			<QuestionPlanShortStayParams />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionPlanStayLength.displayName = "QuestionPlanStayLength";
